import { render, staticRenderFns } from "./AddPayment.vue?vue&type=template&id=36016f25"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports